import {axiosPlacement} from "./AxiosInstance";
import { getCached, invalidateCache } from "./dataCache";

export const getOrganizations = async (limit = 10, page = 1, filters = {}) => {
  const response = await axiosPlacement.post(`/organizations/searchOrgs`, {
    ...filters,
    limit,
    page
  });
  return response.data;
};

export const searchOrganizations = async (payload) => {
  try {
    const response = await axiosPlacement.post(`/organizations/searchOrgs`, payload);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to search organizations: ${error.message}`);
  }
};

// ✅ Get single organization by ID
export const getOrganizationById = async (id) => {
  try {
    const response = await axiosPlacement.get(`/organizations/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch organization: ${error.message}`);
  }
};

// ✅ Get contacts for a specific organization
export const getOrganizationContacts = async (organizationId) => {
  try {
    const response = await axiosPlacement.get(`/organizations/${organizationId}/contacts`);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch organization contacts: ${error.message}`);
  }
};

export const createOrganization = async (organizationData) => {
  try {
    const response = await axiosPlacement.post(`/organizations`, organizationData);
    invalidateCache();
    return response.data;
  } catch (error) {
    throw new Error(`Failed to create organization: ${error.message}`);
  }
};

export const updateOrganization = async (id, updatedFields) => {
  try {
    if (!id || id === 'undefined' || id === 'null') {
      throw new Error('Organization ID is required for update');
    }
    
    const response = await axiosPlacement.put(`/organizations/${id}`, updatedFields);
    invalidateCache();
    return response.data;
  } catch (error) {
    throw new Error(`Failed to update organization: ${error.message}`);
  }
};

export const replaceOrganization = async (id, newOrganizationData) => {
  try {
    const response = await axiosPlacement.put(`/organizations/${id}`, newOrganizationData);
    invalidateCache();
    return response.data;
  } catch (error) {
    throw new Error(`Failed to replace organization: ${error.message}`);
  }
};

export const deleteOrganization = async (id) => {
  try {
    await axiosPlacement.delete(`/organizations/${id}`);
    invalidateCache();
    return id;
  } catch (error) {
    throw new Error(`Failed to delete organization: ${error.message}`);
  }
};
